import { gql } from '@/__generated__';

const GET_MATH_MODELING_DATA = gql(`#graphql
  query MathModeling_GetDeviceData($input: DeviceInput!) {
    device(input: $input) {
      id
      profile {
        id
        sensor
      }
      dataConfiguration {
        deviceId
        mathModeling {
          id
          flowModel {
            expression
          }
          calculatedAngleModel {
            expression
          }
        }
      }
    }
  }
`);

export default GET_MATH_MODELING_DATA;
